module.exports = __webpack_public_path__ + "static/media/art14.399de52f.jpg";